module.exports = __webpack_public_path__ + "static/media/solution-sale.99432f7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/solution-sale.svg
// module id = 170
// module chunks = 6